import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/styles";
import styles from "../../styles/main";
import stylesMembers from "../../styles/members";
import { Typography } from "@material-ui/core";
import MyButton from "../../components/button";
import { Link } from "react-router-dom";
import ConfirmDialog from "../../components/dialog";
import { withSnackbar } from "notistack";
import { showInfo, showError } from "../../helpers/notification";
import { getWarrants, removeWarrant } from "../../services/warrants";
import { initACL } from "../../helpers/acl";
import MyTextField from "../../components/textField";

class Warrants extends Component {
  state = {
    warrantsAll: [],
    warrants: [],
    deleteDialog: false,
  };

  componentDidMount = () => {
    getWarrants()
      .then((data) => {
        if (data.forbidden === true) {
          showError(this.props, "عملیات غیر مجاز");
          return;
        }
        this.setState({ warrants: data, warrantsAll: data });
      })
      .catch((error) => {});
  };

  handleRemove = (warrantId) => {
    removeWarrant(warrantId)
      .then((data) => {
        if (data.forbidden === true) {
          showError(this.props, "عملیات غیر مجاز");
          return;
        }
        showInfo(this.props, "حق تقدم با موفقیت حذف گردید");
        this.setState({
          warrants: this.state.warrants.filter((per) => per._id !== warrantId),
          warrantsAll: this.state.warrantsAll.filter(
            (per) => per._id !== warrantId
          ),
        });
      })
      .catch((error) => {});
  };

  openDeleteDialog = (warrantId) =>
    this.setState({ deleteDialog: true, deleteId: warrantId });

  closeDeleteDialog = () => this.setState({ deleteDialog: false, deleteId: 0 });

  handleDeleteDialogConfirm = () => {
    this.handleRemove(this.state.deleteId);
    this.closeDeleteDialog();
  };

  handleSearch = (event) => {
    this.setState({ [event.target.name]: event.target.value });

    let search = event.target.value;
    if (search && search.length > 0) {
      search = search.replace(/ك/gi, "ک");
      search = search.replace(/ي/gi, "ی");
      this.setState({
        warrants: this.state.warrantsAll.filter(
          (per) => per.name && per.name.includes(search)
        ),
      });
    } else this.setState({ warrants: this.state.warrantsAll });
  };

  render() {
    const { classes } = this.props;
    const { warrants } = this.state;
    const {
      enableEditButton,
      enableDeleteButton,
      enableAddButton,
      search,
      first_name,
      last_name,
      sending,
      success,
      fail,
    } = this.state;

    return (
      <div /*className={classes.memberScroll}*/>
        <ConfirmDialog
          title="حذف حق تقدم"
          content="آیا از حذف مطمئن هستید؟"
          open={this.state.deleteDialog}
          handleConfirm={this.handleDeleteDialogConfirm}
          handleCancel={this.closeDeleteDialog}
        />

        <Grid
          container
          direction="row"
          justify="center"
          spacing={2}
          style={{ marginBottom: "16px" }}
        >
          <Grid item>
            <Link to="/warrants/new" style={{ textDecoration: "none" }}>
              <MyButton className={classes.new} variant="contained">
                حق تقدم جدید
              </MyButton>
            </Link>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justify="center"
          spacing={2}
          style={{ marginBottom: "16px" }}
        >
          <Grid item>
            <MyTextField
              id="search"
              name="search"
              value={search}
              onChange={this.handleSearch}
              classes={classes}
              margin="dense"
              variant="outlined"
              type="text"
              placeholder="جستجو"
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row-reverse"
          spacing={3}
          style={{ marginBottom: "16px" }}
        >
          {warrants.map((warrant, index) => (
            <Grid key={index} item xs={12}>
              <Grid
                container
                direction="row"
                alignItems="center"
                spacing={2}
                className={classes.memberContent}
              >
                <Grid
                  item
                  container
                  direction="row"
                  xs={12}
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item container direction="column" xs={1} spacing={1}>
                    <Grid item>
                      <Link to={`/warrants/${warrant._id}`}>
                        <img
                          src={require(`../../images/icon_edit.png`)}
                          className={classes.editIcon}
                          title="ویرایش حق تقدم"
                        />
                      </Link>
                    </Grid>

                    <Grid item>
                      <img
                        src={require(`../../images/icon_delete.png`)}
                        className={classes.editIcon}
                        onClick={() => this.openDeleteDialog(warrant._id)}
                        title="حذف حق تقدم"
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    container
                    direction="column"
                    alignItems="flex-end"
                    xs={11}
                    spacing={1}
                  >
                    <Grid
                      item
                      container
                      direction="row"
                      justify="flex-end"
                      spacing={1}
                    >
                      <Grid item xs={11}>
                        <Typography
                          className={classes.memberName}
                          style={{ textAlign: "right", color: "DarkBlue" }}
                        >
                          {`${warrant.name}`}
                        </Typography>
                      </Grid>
                      <Grid item xs={1}>
                        <Typography className={classes.memberName}>
                          :نماد
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      container
                      direction="row"
                      justify="flex-end"
                      spacing={1}
                    >
                      <Grid item xs={11}>
                        <Typography
                          className={classes.memberName}
                          style={{ textAlign: "right", direction: "rtl" }}
                        >
                          {`${warrant.start_date} - ${warrant.end_date}`}
                        </Typography>
                      </Grid>
                      <Grid item xs={1}>
                        <Typography className={classes.memberName}>
                          :تاریخ
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      container
                      direction="row"
                      justify="flex-end"
                      spacing={1}
                    >
                      <Grid item>
                        <Typography
                          className={classes.memberName}
                          style={{ textAlign: "right", color: "Red" }}
                        >
                          {warrant.show == false ? "پنهان" : ""}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography className={classes.memberName}>
                          {warrant.type ? `${warrant.type}` : ""}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography className={classes.memberName}>
                          {warrant.increase_percent
                            ? `%${warrant.increase_percent}`
                            : ""}
                        </Typography>
                      </Grid>
                      <Grid item xs={1}></Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {/*<Grid item xs={3}>
                  <img
                    src={require(`../../images/icon_user.png`)}
                    className={classes.memberImage}
                    alt=""
                  />
                        </Grid>*/}
              </Grid>
            </Grid>
          ))}
        </Grid>
        {enableAddButton && (
          <Link to="/templateAnswers/new" style={{ textDecoration: "none" }}>
            <MyButton className={classes.new} variant="contained">
              ثبت حق تقدم جدید
            </MyButton>
          </Link>
        )}
      </div>
    );
  }
}

export default withStyles({ ...styles, ...stylesMembers })(
  withSnackbar(Warrants)
);
